export default class {
	idPedido
	constructor(idPedido) {
		this.idPedido = idPedido
	}
}
